import React, { useState } from 'react';
import { db } from '../FirebaseComp/firebase'; 
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { FaUserShield, FaHandsHelping, FaChartLine, FaCheckCircle } from 'react-icons/fa';
import './jointoeffort.css';

function JoinToEffort() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    category: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      // Add document to Firestore
      await addDoc(collection(db, 'jointoeffort'), {
        ...formData,
        createdAt: serverTimestamp(),
        status: 'pending'
      });
      
      setIsSuccess(true);
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        category: '',
        message: ''
      });
    } catch (err) {
      console.error('Error adding document: ', err);
      setError('Failed to submit application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) {
    return (
      <section className="join-effort-section">
        <div className="join-effort-container">
          <div className="success-message">
            <FaCheckCircle className="success-icon" />
            <h2>Application Submitted Successfully!</h2>
            <p>Thank you for your interest in joining the Ceylon Eye Care Optometry Association.</p>
            <p>Our team will review your application and contact you shortly.</p>
            <button 
              onClick={() => setIsSuccess(false)}
              className="submit-button"
            >
              Submit Another Application
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="join-effort-section">
      <div className="join-effort-container">
        <div className="join-effort-header">
          <h2 className="join-effort-title">Join Our Professional Network</h2>
          <div className="title-divider"></div>
          <p className="join-effort-subtitle">
            Become part of Ceylon Eye Care Optometry Association's mission to elevate eye care standards across Sri Lanka
          </p>
        </div>

        <div className="join-effort-content">
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">
                <FaUserShield />
              </div>
              <h3 className="benefit-title">Professional Development</h3>
              <p className="benefit-description">
                Access exclusive training programs, workshops, and certification courses to enhance your clinical skills.
              </p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">
                <FaHandsHelping />
              </div>
              <h3 className="benefit-title">Community Impact</h3>
              <p className="benefit-description">
                Participate in nationwide initiatives that bring quality eye care to underserved communities.
              </p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">
                <FaChartLine />
              </div>
              <h3 className="benefit-title">Career Advancement</h3>
              <p className="benefit-description">
                Connect with industry leaders and access career opportunities through our professional network.
              </p>
            </div>
          </div>

          <div className="membership-form-container">
            <div className="form-header">
              <h3 className="form-title">Ready to Join Us?</h3>
              <p className="form-subtitle">Complete this form to begin your membership application</p>
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <form className="membership-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input 
                  type="text" 
                  name="name"
                  placeholder="Full Name" 
                  className="form-input" 
                  value={formData.name}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="email" 
                  name="email"
                  placeholder="Email Address" 
                  className="form-input" 
                  value={formData.email}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="tel" 
                  name="phone"
                  placeholder="Phone Number" 
                  className="form-input" 
                  value={formData.phone}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <select 
                  name="category"
                  className="form-input" 
                  value={formData.category}
                  onChange={handleChange}
                  required
                >
                  <option value="">Professional Category</option>
                  <option value="optometrist">Optometrist</option>
                  <option value="ophthalmologist">Ophthalmologist</option>
                  <option value="student">Student</option>
                  <option value="other">Other Eye Care Professional</option>
                </select>
              </div>
              <div className="form-group">
                <textarea 
                  name="message"
                  placeholder="Why do you want to join our association?" 
                  className="form-input textarea" 
                  rows="4" 
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Application'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default JoinToEffort;